import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import { MSAL_SCOPES } from "components/Intune/IntuneScopes";
import { resetIntuneMsalInstance } from "components/Intune/intuneMsal";

export const authStorage = {
  getTenantId: () => sessionStorage.getItem("selectedTenantId"),
  setTenantId: (id: string) => sessionStorage.setItem("selectedTenantId", id),

  getHomeAccountId: () => sessionStorage.getItem("home_account_id"),
  setHomeAccountId: (id: string) =>
    sessionStorage.setItem("home_account_id", id),

  // The tenant picker's display name, kept alongside the tenant/account ids so it
  // survives the full-page MSAL redirect (loginRedirect navigates away, wiping Redux/React state).
  getTenantDisplayName: () => sessionStorage.getItem("selectedTenantDisplayName"),
  setTenantDisplayName: (name: string | null) => {
    if (name) {
      sessionStorage.setItem("selectedTenantDisplayName", name);
    } else {
      sessionStorage.removeItem("selectedTenantDisplayName");
    }
  },

  getAutoLoginAttempted: () => sessionStorage.getItem("autoLoginAttempted") === "true",
  setAutoLoginAttempted: () => sessionStorage.setItem("autoLoginAttempted", "true"),
  clearAutoLoginAttempted: () => sessionStorage.removeItem("autoLoginAttempted"),

  clear: () => {
    sessionStorage.removeItem("home_account_id");
    sessionStorage.removeItem("selectedTenantId");
    sessionStorage.removeItem("selectedTenantDisplayName");
    resetIntuneMsalInstance();
  },
};

export const isTokenValid = (token: string | null) => {
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp > now;
  } catch {
    return false;
  }
};

export const acquireBackendTokenSilent = async (
  instance: PublicClientApplication
): Promise<string | null> => {
  const homeAccountId = authStorage.getHomeAccountId();
  const tenantId = authStorage.getTenantId();

  if (!homeAccountId || !tenantId) return null;

  const account = instance.getAllAccounts().find(
    (acc: AccountInfo) =>
      acc.homeAccountId === homeAccountId && acc.tenantId === tenantId
  );

  if (!account) return null;

  try {
    const tokenResponse = await instance.acquireTokenSilent({
      account,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      scopes: MSAL_SCOPES,
    });

    return tokenResponse.accessToken;
  } catch (error) {
    console.error("Token acquisition failed:", error);
    return null;
  }
};

